import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const SectorContent = ({data}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.sectorsWithMoreAttendance?.sort((a, b) => b.qty - a.qty).forEach((item) => {
            labels.push(ReportUtils.formatText(item.sector));
            values.push(item.qty);
        });

        ReportUtils.createExportableTable(labels, values, "Atendimentos por setor");
        GraphicUtils.barChart('sectors-with-more-attendance', values.slice(0, 10), labels.slice(0, 10), false);
    }, [data]);

    return (
        <>
            <div className="chart-report">
                <div className="chart-title mb-3">Atendimentos por setor {data.sectorsWithMoreAttendance.length >= 10 ? ' (TOP 10)' : ''}</div>
                <div className="chart-report" id="sectors-with-more-attendance"></div>
                <span className="obs-warn">* Um atendimento pode estar associado a múltiplos setores.</span>
            </div>
        </>
    );
};

export default SectorContent;